import { css } from 'emotion';
import { theme } from '@branchjs/neo-components';

const ContentContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const Image = css`
  margin-bottom: 36px;
`;

const Title = css`
  margin-bottom: 16px;
  color: ${theme.colors.text[900]} !important;
`;

const Description = css`
  margin-bottom: 24px;
  color: ${theme.colors.gray[800]} !important;
  max-width: 660px;
  padding: 0 24px;
  text-align: center;
`;

export const ScreenOutOfServiceStyles = {
  ContentContainer,
  Image,
  Title,
  Description,
};
